import type { ElementType, ReactNode } from 'react';
import { Button, Icon, Popover } from '@chakra-ui/react';

interface OverflowActionItemProps {
	children: ReactNode;
	onClick: () => void;
	icon?: ElementType;
	/** Applies destructive (red) styling. Defaults to a normal action. */
	destructive?: boolean;
	disabled?: boolean;
	loading?: boolean;
}

/** A single action row inside OverflowActionsMenu. Closes the menu when clicked. */
const OverflowActionItem = (props: OverflowActionItemProps) => {
	const { children, onClick, icon, destructive = false, disabled = false, loading = false } = props;
	const ariaLabel = typeof children === 'string' ? children : undefined;

	return (
		<Popover.CloseTrigger asChild>
			<Button
				aria-label={ariaLabel}
				w="100%"
				justifyContent="flex-start"
				borderRadius="xl"
				variant="ghost"
				color={destructive ? 'red.600' : 'brand.fg'}
				_hover={destructive ? { bg: 'red.50', color: 'red.700' } : { bg: 'surface.subtle' }}
				onClick={onClick}
				disabled={disabled}
				loading={loading}
			>
				{icon && <Icon as={icon} boxSize={4} />}
				{children}
			</Button>
		</Popover.CloseTrigger>
	);
};

export default OverflowActionItem;
